// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('BannerSection')

function BannerSection(props) {
  const { domain } = props
  if (!domain) {
    return null
  }
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('banner-text')
      },
        'Sign in to continue mixing from ',
        domain
      )
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  BannerSection.propTypes = {
    // Values
    domain: PropTypes.string
  }
}

module.exports = BannerSection
